import { useTranslation } from "next-i18next";
import React from "react";
import { Container } from "react-bootstrap";
import HeaderVideoPlayer from "./HeaderVideoPlayer/HeaderVideoPlayer";
import classes from "./CareerHeader.module.scss";
import useWindowDimensions from "components/hooks/useWindowDimension";

const CareerHeader = () => {
  const { t } = useTranslation("career");
  const { width } = useWindowDimensions();
  const smallOrLower: boolean = width < 768;

  return (
    <div className={classes.careerHeader}>
      {!smallOrLower && (
        <div className={classes.careerHeader__videoWrapper}>
          <HeaderVideoPlayer />
        </div>
      )}

      <Container className="pt-8 pb-7">
        <h1 className="mb-3 text-uppercase">{t("title")}</h1>
        <p className="text-black display-6">{t("we_are_not_corporate")}</p>
      </Container>
    </div>
  );
};

export default CareerHeader;
